import React from 'react';
import { Grid } from '@mui/material';

import {
	BooleanDescField,
	DateTimeField,
	ModuleSearchField,
	SearchSelectField,
	SimpleTextField,
	TagsSelectField,
	useUserData,
	useSettings
} from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function ChronologyDetailsSectionInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();
	const userData = useUserData();

	return (
		<>
			<Grid size={{ sm: 9, xs: 12 }}>
				{/* TITLE */}
				<SimpleTextField
					name="chro_title"
					label={t('DETAILS_CHRONOLOGY_FIELD_TITLE')}
					value={props.model.chro_title}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ sm: 3, xs: 12 }}>
				{/* DATE */}
				<DateTimeField
					name="chro_date"
					label={t('DETAILS_CHRONOLOGY_FIELD_DATE')}
					value={props.model.chro_date}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* STATUS */}
				<SearchSelectField
					name="chro_chst_id"
					label={t('DETAILS_CHRONOLOGY_FIELD_STATUS')}
					systable="chronology_statuses"
					value={props.model.chro_chst_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* TYPE */}
				<SearchSelectField
					name="chro_chty_id"
					label={t('DETAILS_CHRONOLOGY_FIELD_TYPE')}
					systable="chronology_types"
					value={props.model.chro_chty_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={12}>
				{/* COMPANY */}
				<ModuleSearchField
					name="chro_comp_uid"
					label={t('DETAILS_CHRONOLOGY_FIELD_COMPANY')}
					module="companies"
					uid={props.model.chro_comp_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* USER */}
				<ModuleSearchField
					name="chro_user_assigned_uid"
					label={t('DETAILS_CHRONOLOGY_FIELD_ASSIGNED_USER')}
					module="users"
					filters={[{ filt_field: 'user_role_external', filt_clause: 'equals', filt_value: 1 }]}
					uid={props.model.chro_user_assigned_uid}
					isEdit={props.isEdit && !userData.user_role_external}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* USER */}
				<ModuleSearchField
					name="chro_user_assigned_2_uid"
					label={t('DETAILS_CHRONOLOGY_FIELD_ASSIGNED_USER_2')}
					module="users"
					filters={[{ filt_field: 'user_role_external', filt_clause: 'equals', filt_value: 1 }]}
					uid={props.model.chro_user_assigned_2_uid}
					isEdit={props.isEdit && !userData.user_role_external}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* WARNING */}
				<BooleanDescField
					name="chro_warning_desc"
					label={t('DETAILS_CHRONOLOGY_FIELD_WARNING')}
					value={props.model.chro_warning_desc}
					icon="alert-outline"
					color="warning.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* BLOCKED */}
				<BooleanDescField
					name="chro_blocked_desc"
					label={t('DETAILS_CHRONOLOGY_FIELD_BLOCKED')}
					value={props.model.chro_blocked_desc}
					icon="cancel"
					color="error.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={12}>
				{/* TAGS */}
				<TagsSelectField
					name="chro_tags"
					label={t('DETAILS_CHRONOLOGY_FIELD_TAGS')}
					value={props.model.chro_tags}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
